import { isDateValid } from "../../common";
//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("./is-empty");

export function validateSampleDetailsInput(data) {
  let validationErrors = {};

  data.countryOfOrigin = !isEmpty(data.countryOfOrigin)
    ? data.countryOfOrigin
    : "";
  data.receivedProductClass = !isEmpty(data.receivedProductClass)
    ? data.receivedProductClass
    : "";
  data.receivedItemDescription = !isEmpty(data.receivedItemDescription)
    ? data.receivedItemDescription
    : "";
  data.brand = !isEmpty(data.brand) ? data.brand : "";
  data.packaging = !isEmpty(data.packaging) ? data.packaging : "";
  data.productionDate = !isEmpty(data.productionDate)
    ? data.productionDate
    : "";
  data.receiptDate = !isEmpty(data.receiptDate) ? data.receiptDate : "";
  data.expiryDate = !isEmpty(data.expiryDate) ? data.expiryDate : "";
  data.primaryImagesToUpload = !isNaN(data.primaryImagesToUpload)
    ? data.primaryImagesToUpload
    : 0;
  data.secondaryImagesToUpload = !isNaN(data.secondaryImagesToUpload)
    ? data.secondaryImagesToUpload
    : 0;

  //check if date is valid
  if (!isDateValid(data.productionDate)) {
    validationErrors.productionDate =
      "Production date field should be a valid date";
  }
  if (!isDateValid(data.receiptDate)) {
    validationErrors.receiptDate = "Receipt date field should be a valid date";
  }
  if (!isDateValid(data.expiryDate)) {
    validationErrors.expiryDate = "Expiry date field should be a valid date";
  }

  //check if fields are empty
  if (Validator.isEmpty(data.countryOfOrigin)) {
    validationErrors.countryOfOrigin = "Country Of Origin field is required";
  }
  if (Validator.isEmpty(data.brand)) {
    validationErrors.brand = "Brand field is required";
  }
  if (Validator.isEmpty(data.receivedProductClass)) {
    validationErrors.receivedProductClass =
      "Received Product Class field is required";
  }
  if (Validator.isEmpty(data.receivedItemDescription)) {
    validationErrors.receivedItemDescription =
      "Received Item Description field is required";
  }
  if (Validator.isEmpty(data.packaging)) {
    validationErrors.packaging = "Packaging field is required";
  }

  if (Validator.isEmpty(data.productionDate)) {
    validationErrors.productionDate = "Production date field is required";
  }
  if (Validator.isEmpty(data.receiptDate)) {
    validationErrors.receiptDate = "Receipt date field is required";
  }
  if (Validator.isEmpty(data.expiryDate)) {
    validationErrors.expiryDate = "Expiry date field is required";
  }
  if (!data.primaryImagesToUpload) {
    validationErrors.primaryImagesToUpload =
      "Primary Packaging Image is required";
  }
  if (!data.secondaryImagesToUpload) {
    validationErrors.secondaryImagesToUpload =
      "Secondary Packaging Image is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
